import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-full w-full flex-col gap-10',
    drawer: 'py-[20px] pb-0 sm:py-12 sm:pb-0 lg:w-[890px]',
    resetButton:
      'text-secondary-hover h-fit self-end p-0 text-sm font-semibold',
    header: 'flex flex-col gap-4',
    titleWrapper: 'flex items-center gap-2 md:justify-between',
    title: 'text-xl font-semibold md:text-3xl',
    description: 'text-s leading-normal font-light',
    filters: '-mr-3 flex flex-col gap-10 overflow-y-auto pr-3',
    filter: 'flex flex-col gap-x-4 gap-y-2',
    question: 'text-s mb-3 leading-normal font-semibold',
    footer: 'sticky bottom-0 mt-auto flex bg-white pb-2.5',
    showProductsButton:
      'bg-primary hover:bg-blue bg-blue-dark w-full rounded py-3 font-medium text-white disabled:cursor-not-allowed disabled:bg-gray-300',
    careButton:
      'flex h-10 w-fit cursor-pointer bg-gradient-to-r from-[#DAE8FF] to-[#E6F9FF] max-sm:px-0 sm:pr-5 sm:pl-3',
    careElementContent: 'heading-s-bold flex-center relative w-full gap-2',
    careElementImage: 'flex-center size-9.5 self-end object-contain',
    clearButton:
      'flex-center bg-main hover:text-bg-items-white hover:bg-secondary-hover flex size-6 border-none border-white p-0 text-white max-sm:absolute max-sm:top-1/2 max-sm:right-2 max-sm:-translate-y-1/2 sm:ml-1',
    clearButtonIconWrapper: 'flex-center size-fit text-white'
  },
  variants: {
    hasSelectedCareOptions: {
      true: {
        careButton: 'sm:pr-2'
      }
    }
  }
});
